/* eslint-disable global-require,import/no-unresolved, react/forbid-prop-types, react/no-array-index-key */
import React from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import styles from '../../../styles'
import textStyles from '../../../styles/text'
import buttonStyles from '../../../styles/button'
import { covidStudyWebTap } from '../../../actions/helpers'

function CovidStudy() {
  const { t } = useTranslation('faq')
  return (
    <View>
      <View style={textStyles.faqH1Container}>
        <Text style={[textStyles.h1, styles.shark_grey]} testID="covid19StudyFaq">{t('covidNoticeDetailTitle')}</Text>
      </View>
      <View>
        <Text style={[textStyles.bodyContentText]} testID="covid-study-content1">{t('covidNoticeDetailContent1')}</Text>
        <Text style={[textStyles.bodyContentTextBold]} testID="covid-study-content2">{t('covidNoticeDetailContent2')}</Text>
        <Text style={[textStyles.bodyContentText]} testID="covid-study-content3">
          <Text style={{ fontWeight: 'bold' }}>{t('covidNoticeDetailContent3')}</Text>
          {' '}
          {t('covidNoticeDetailContent4')}
          {' '}
          <Text style={{ fontWeight: 'bold' }}>{t('covidNoticeDetailContent5')}</Text>
        </Text>
        <Text style={[textStyles.bodyContentText]} testID="manual-transmit-paragraph3">{t('covidNoticeDetailContent6')}</Text>

        <TouchableOpacity
          testID="covidStudyLaunchButton-button"
          onPress={() => {
            covidStudyWebTap()
          }}
          style={styles.blueButton}
        >
          <Text
            maxFontSizeMultiplier={1.5}
            style={[buttonStyles.buttonText, styles.white]}
          >
            {t('covidNoticeDetailButtonText')}
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  )
}
export default CovidStudy
